import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  addComponentStatusRequest,
  addComponentStatusSuccess,
  addComponentStatusFailure,
} from '../reducers/addComponentStatus';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* addComponentStatusAxios() {
  const state = yield select(fullState => fullState);
  const { userId } = state.loginReducer.user;
  const { selectedContentId: contentId } = state.userProgramsFullReducer;
  const { timeTaken, status } = state.addComponentStatus;
  const { token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'put',
      url: `${API}${userId}/content/${contentId}/status`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        status,
        timeTaken,
      },
    }),
  );

  return response;
}

function* addComponentStatusSaga() {
  console.log('MESSAGE_STATUS')
  try {
    const response = yield call(addComponentStatusAxios);

    yield put(addComponentStatusSuccess(response.data));
  } catch (error) {
    yield put(addComponentStatusFailure(error));
  }
}

export function* watcherAddComponentStatusSaga() {
  yield takeLatest(addComponentStatusRequest().type, addComponentStatusSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_addComponentStatus.js